import Vue from 'vue'
import Vuex from 'vuex'

import UsersModule from "./modules/users/index.js";
import UserGroupsModule from "./modules/usersGroups/index.js"
import AuditTrailModule from "./modules/auditTrail/index.js"
import StorageReportModule from "./modules/storageReport/index.js"
import IngestReportModule from "./modules/ingestReport/index.js"
import JobsReportsModule from "./modules/jobsReport/index.js"
import DownloadReportModule from "./modules/downloadReport/index.js"
import ArchiveReportModule from "./modules/archiveReport/index.js"
import newArchiveReport from "./modules/newArchiveReport/index.js";
import RetrieveReportModule from "./modules/retrieveReport/index.js"
import BinsModule from "./modules/bins/index.js";
import FilesModule from "./modules/files/index.js"
import CategoriesModule from "./modules/categories/index.js"
import TagsModule from "./modules/tags/index.js"
import CustomMetadata from "./modules/customMetadata/index.js"
import ScreensModule from "./modules/screens/index.js"
import MetadataProfile from "./modules/metadataProfiles/index.js"
import MetadataApprover from "./modules/metadataApprover/index.js"
import AssetsModule from "./modules/assets/index.js"
import PrivilegesModule from "./modules/privileges/index.js"
import LocationsModule from "./modules/locations/index.js";
import Jobs from "./modules/Jobs/index.js";
import Settings from "./modules/settings/index.js";
import PluginRepo from "./modules/pluginsRepo/index.js";
import Actions from "./modules/actions/index.js"
import RegistryModule from "./modules/registry/index.js";
import UploadModule from "./modules/upload/index.js";
import DownloadModule from "./modules/download/index.js";
import WebsocketModule from "./modules/websocket/index.js";
import StartUpData from "./modules/startUpData/index.js";
import proxy from './modules/proxy/index.js';
// import transcoder from './modules/transcoder/index.js';
// import reviewWorkspaceModule from "./modules/reviewWorkspce/index.js";
import reviewModule from "./modules/review/index.js";
//import PAMModule from "./modules/PAM/index.js";
import searchModule from "./modules/search/index.js";
import miscModule from "./modules/miscellaneous/index.js";
// import sharedAssetsModule from "./modules/sharedAssets/index.js";
import hypeModule from "./modules/hype/index.js";
import remoreSystemStatsModule from "./modules/remoteSystemStats/index.js";
import poolsModule from "./modules/pools/index.js"
import webHookModule from "./modules/webHook/index.js";
import dashboardModule from "./modules/dashboard/index.js";
import schedulerTaskModule from "./modules/scheduler/index.js";
import favoritesModule from "./modules/favorites/index.js";
//import transciptModule from "./modules/transcript/index.js";

//import ocrModule from "./modules/ocr/index";

//import versionsModule from "./modules/manageVersions/index.js";
import playerModule from './modules/player/index.js';
// import editProModule from "./modules/editPro/index.js";

//import faceDetectionModule from "./modules/faceDetection/index.js";
import AIDataSetModule from "./modules/AIDataSet/index.js";
import labelsModule from "./modules/labels/index.js";
//import mediaPipelineModule from "./modules/mediaPipeline/index.js";
//import mediaQCModule from "./modules/mediaQC/index.js";
import beforeAuth from "./modules/beforeLogin/index.js";
import languageData from "./modules/language/index.js";
import searchAliasModule from "./modules/alias/index.js";
import quertBuilderModule from "./modules/queryBuiler/index.js";
import buttonsModule from "./modules/buttons/index.js";

Vue.use(Vuex)

const store = new Vuex.Store({
    state() {
        return {};
    },
    actions: {},
    mutations: {},
    getters: {},
    modules: {
        users: UsersModule,
        userGroups: UserGroupsModule,
        bins: BinsModule,
        files: FilesModule,
        auditTrails: AuditTrailModule,
        storageReports: StorageReportModule,
        ingestReports:IngestReportModule,
        jobsReports: JobsReportsModule,
        archiveReports:ArchiveReportModule,
        retrieveReports:RetrieveReportModule,
        downloadReports:DownloadReportModule,
        categories: CategoriesModule,
        tags: TagsModule,
        customMetadata: CustomMetadata,
        screens: ScreensModule,
        metadataProfiles:MetadataProfile,
        assets: AssetsModule,
        privileges: PrivilegesModule,
        jobs: Jobs,
        settings: Settings,
        pluginRepo: PluginRepo,
        actions: Actions,
        locations: LocationsModule,
        registry: RegistryModule,
        upload: UploadModule,
        download: DownloadModule,
        websocket: WebsocketModule,
        startUpData: StartUpData,
        proxy,
        // transcoder,
        // reviewWorkspaceData:reviewWorkspaceModule,
        reviewDataTemp:reviewModule,
        //PAM:PAMModule,
        search:searchModule,
        miscellaneous:miscModule,
        // sharedAssets:sharedAssetsModule,
        hype:hypeModule,
        remoreSystemStats:remoreSystemStatsModule,
        metadataApprover:MetadataApprover,
        pools:poolsModule,
        webHook:webHookModule,
        dashboard:dashboardModule,
        schedulerTask:schedulerTaskModule,
        favorites:favoritesModule,
        // editpro:editProModule,
        //ocr:ocrModule,
        //transcript:transciptModule,
        //faceDetection:faceDetectionModule,
        AIDataSet:AIDataSetModule,
       // versions:versionsModule,
        player: playerModule,
        label:labelsModule,
        // mediaPipeline:mediaPipelineModule,
        // mediaQC:mediaQCModule,
        beforeAuth: beforeAuth,
        language:languageData,
        alias:searchAliasModule,
        queryBuilder:quertBuilderModule,
        newArchiveReport: newArchiveReport,
        buttons:buttonsModule
    },
});

export default store;